//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InTitle from "@/views/stencil/components/title";
import { get } from "lodash";
export default {
  name: "detail__schemes",
  props: {
    schemes: {
      type: Array,
      default: () => [],
    },
    selectedScheme: {
      type: Object,
    },
    productName: {
      type: String,
      default: "获取中...",
    },
  },
  components: {
    InTitle,
  },
  computed: {
    selectedSchemeDuty() {
      return get(this.selectedScheme, "duty", "获取中...");
    },
    selectedSchemeCode() {
      return get(this.selectedScheme, "schemeCode");
    },
  },
  methods: {
    onSchemeChange(scheme) {
      this.$emit("onSchemeChange", scheme);
    },
  },
};
